<template>
    <div class="row">
        <div class="col-12">
            <div class="row">
                <div class="col-md-12 col-lg-12">
                    <div class="row">
                        <!-- Stats Cards -->
                        <div class="col-sm-6 col-md-4 col-lg-4">
                            <DIDCard>
                            </DIDCard>
                        </div>
                        <div class="col-sm-6 col-md-4 col-lg-4">
                            <SIPDeviceCard>
                            </SIPDeviceCard>
                        </div>
                        <div class="col-sm-6 col-md-4 col-lg-4">
                            <BillingBalanceCard>
                            </BillingBalanceCard>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12">
                    <card type="graph">
                        <template slot="header">
                            <h5 class="card-category">Calls past 12 months</h5>
                        </template>
                        <c-d-r-graph></c-d-r-graph>
                    </card>

                </div>
                <div class="col-md-12 col-lg-12">
                    <card type="table">
                        <template slot="header">
                            <h5 class="card-category">Recent Calls</h5>
                        </template>
                        <CDRTable data-app></CDRTable>
                    </card>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import StatsCard from 'src/components/Cards/StatsCard';
    import DIDCard from "./DIDCard";
    import SIPDeviceCard from "./SIPDeviceCard";
    import BillingBalanceCard from "./BillingBalanceCard";
    import CDRTable from '../CDR/CDRTable';
    import CDRGraph from "../../components/CDR/CDRGraph";

    export default {
        components: {
            CDRGraph,
            DIDCard,
            SIPDeviceCard,
            BillingBalanceCard,
            StatsCard,
            CDRTable
        },
        data() {
            return {};
        },
        computed: {
            enableRTL() {
                return this.$route.query.enableRTL;
            },
            isRTL() {
                return this.$rtl.isRTL;
            },
        },
        methods: {},
        mounted() {
            this.i18n = this.$i18n;
            if (this.enableRTL) {
                this.i18n.locale = 'ar';
                this.$rtl.enableRTL();
            }

        },
        beforeDestroy() {
            if (this.$rtl.isRTL) {
                this.i18n.locale = 'en';
                this.$rtl.disableRTL();
            }
        }
    };
</script>
<style></style>
